import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import fileDownload from 'js-file-download'
import moment from 'moment/moment'
export class TicketService extends BaseService {
  static async fetchAll (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.search'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getOne (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.getdetail'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async insert (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.insert'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  
  static async assign (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.assign'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async start (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.start-flow'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async update (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.update'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async new (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.new'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async complete (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.approve'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancel (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.cancel'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async pending (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.pending'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async processing (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.processing'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchProduct (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.product.get-all'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  
  static async export (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.export'), params, {
        responseType: 'blob'
      })

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(response.data, 'Export_Ticket' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchWork (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.list-flow-activities'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchGroup (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.group.get-all'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createGroup (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.group.create'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailGroup (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.group.get-by-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateGroup (params) {
      try {
          const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.group.update'), params)
          return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            const message = error.response.data ? error.response.data.error : error.response.statusText
            throw new ErrorWrapper(error, message)
    }
  }
  static async fetchCategory () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category.get-all'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        throw new ErrorWrapper(error, message)
    }
}
static async getDetailCategory (params) {
  try {
    const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category.get-by-id'), params)
    return new ResponseWrapper(response, response.data.data)
  } catch (error) {
    const message = error.response.data ? error.response.data.error : error.response.statusText
    throw new ErrorWrapper(error, message)
  }
}
static async updateCategory (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category.update'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
  }
}
static async createCategory (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category.create'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchSubCategory () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.sub-category.get-all'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        throw new ErrorWrapper(error, message)
    }
}
static async getDetailSubCategory (params) {
  try {
    const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.sub-category.get-by-id'), params)
    return new ResponseWrapper(response, response.data.data)
  } catch (error) {
    const message = error.response.data ? error.response.data.error : error.response.statusText
    throw new ErrorWrapper(error, message)
  }
}
static async updateSubCategory (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.sub-category.update'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
  }
}

  static async getVariable (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category-workflow.config.get-variable'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getCodeWorkflow (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category-workflow.config.get-process'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createConfigWorkflow (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category-workflow.config.update'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createSubCategory (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.sub-category.create'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
  }
}
static async getUserSupervisor (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.get-users-by-type-sale'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
static async getResult () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.list-result-action'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importTicketByExcel (params) {
    try { 
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.import-file'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchHistory (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.history-search'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileTemplate (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.down-file-template'), params, {
        responseType: 'blob'
      })

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(response.data, 'Import_Ticket_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListDepartment () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.ticket.common.list-department'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListWorkType () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.ticket.common.list-ticket-work-type'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListPriority () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.ticket.common.list-priority'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {mi
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateManageInfo (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.update-work'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async fetchCurrentStateTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.list-action-result-template'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async changeAssignee (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.change-assignee'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async updateCurrentState (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.update-action-result-template'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async createCurrentState (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.create-action-result-template'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async changeStatusCurrentStateTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.lock-unlock-action-result-template'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailCurrentState (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.action-result-detail'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailFeedback (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.detail.feedback'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async getActivityId (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.get.activity.id'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async updateFeedback (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.update.feedback.information'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async sendNotiInitAppendix (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.common.send-notify-init-appendix'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async historyUpload (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.history-import'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async changeReceiverSupervisor (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.update.multi.assignee'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async dowloadFileError (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.down-file-error'), params, {
        responseType: 'blob'
      })

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      fileDownload(response.data, 'Import_Ticket_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchTransitionTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.transition.search'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async createTransitionTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.transition.insert'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async updateTransitionTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.transition.update'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async detailTransitionTicket (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.transition.detail'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async transitionActionResult (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.transition.action.result'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async transitionActionResultNextStep (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.transition.action.result.next.step'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async getListTicketCategory (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.category.search'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async getListTicketSubCategory (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.sub-category.search'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async chooseDeviceAssMC (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.user.assign.device'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
  static async makerDevice (params) {
    try {
        const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.ticket.op.maker.device'), params)
        return new ResponseWrapper(response, response.data.data)
      } catch (error) {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          throw new ErrorWrapper(error, message)
    }
  }
}

